const CURRENCIES = [
  {
    country: "BRASIL",
    currency: "BRL",
    symbol: "R$",
    decimal: true,
  },
  {
    country: "CHILE",
    currency: "CLP",
    symbol: "$",
    decimal: false,
  },
  {
    country: "COLOMBIA",
    currency: "COP",
    symbol: "$",
    decimal: true,
  },
  {
    country: "MÉXICO",
    currency: "MXN",
    symbol: "$",
    decimal: true,
  },
  {
    country: "PERÚ",
    currency: "PEN",
    symbol: "S/.",
    decimal: true,
  },
  {
    country: "ESPAÑA",
    currency: "EUR",
    symbol: "€",
    decimal: true,
  },
  {
    country: "ESTADOS UNIDOS",
    currency: "USD",
    symbol: "$",
    decimal: true,
  },
  {
    country: "ESTADOS UNIDOS",
    currency: "",
    symbol: "$",
    decimal: true,
  },
];

function FloorToFixed(num, fixed) {
  fixed = fixed || 0;
  fixed = Math.pow(10, fixed);
  return Math.floor(num * fixed) / fixed;
}

const convertCurrency = (quantity, newCurrency, divider) => {
  if (!newCurrency) {
    newCurrency = 'USD';
  }

  const result = CURRENCIES.reduce((acc, item) => {
    const { country, currency, symbol, decimal } = item;
    let decimalFixed = '';

    if (decimal) {
      decimalFixed = quantity / 100;
      decimalFixed = decimalFixed / divider;
      decimalFixed = FloorToFixed(decimalFixed, 2);
    } else {
      decimalFixed = quantity / divider
      decimalFixed = FloorToFixed(decimalFixed, 0);
    }
    
    if (newCurrency === currency) {
      acc.push({
        country,
        currency,
        symbol,
        decimal,
        decimalFixed,
      });
    }

    return acc;
  }, []);

  return result;
};

export { convertCurrency };
